import axios from "axios";

async function getAgencyDashboardGlobalMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/agency/dashboard-global-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
}

async function getAgencyDashboardGraphMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/agency/dashboard-graph-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
}

async function getDashboardGlobalMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-global-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
}

async function getDashboardGraphMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-graph-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    throw err.response.data;
  }
}

async function getDashboardVideoMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-video-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function getDashboardPageMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-page-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function exportDashboardData(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-data-export`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function getAgencySiteVideosPlays(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/agency/site-videos-plays`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function getAgencyVideoMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/agency/dashboard-video-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function getAgencyPageMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/agency/dashboard-page-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function getDashboardDeviceMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-device-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

async function getDashboardWidgetMetrics(query) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    params: query,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/dashboard-widget-metrics`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
}

export default {
  getDashboardGlobalMetrics,
  getDashboardGraphMetrics,
  getAgencyDashboardGlobalMetrics,
  getAgencyDashboardGraphMetrics,
  getDashboardVideoMetrics,
  getDashboardPageMetrics,
  exportDashboardData,
  getAgencySiteVideosPlays,
  getAgencyVideoMetrics,
  getAgencyPageMetrics,
  getDashboardDeviceMetrics,
  getDashboardWidgetMetrics,
};
